import React, { useState } from 'react';
import axios from 'axios';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import CryptoJS from 'crypto-js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ModalModifyUser = ({ isVisible, onClose, choosenId }) => {

    const [values, setValues] = useState({
        id: '',
        username: '',
        email: '',
        id_pdv: '',
        authorized: '',
        hashed_password: '',
        pages:'all',
        role:'',
        ecran:''
    })

    const handleClose = (e) => {
        if (e.target.id === "wrapper") onClose();
    }

    if (choosenId.id !== values.id) setValues({ ...values, ...choosenId })

    let token = localStorage.getItem("token");

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };

    const handleSubmit = (e) => {

        e.preventDefault();
        // console.log(choosenId);
        if(values.pages == null){
            values.pages = 'all'
        }
        // console.log(values);
        axios.post(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/admin/auth/modifUser`, values, { headers })
            .then(res => {
                console.log(res);
                window.location.reload(false);
            }).catch(err => console.log(err))
        console.log("HERE");

    }
    const dataDelete = {
        "id_pdv": choosenId.id_pdv
    }
    const handleDelete = () => {
        axios.post(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/api/delete/admin`, dataDelete, { headers })
            .then(res => {
                console.log(res);
                window.location.reload(false);
            }).catch(err => console.log(err))
    }
    const close = () => {
        let divTooltip = document.getElementById('popup-2');
        divTooltip.style.display = "none"
    }

    var SECRET_KEY = 'abcedijghtko584lomp12d26e46rtg16'
    const decrypt = (encrypted) => {
        const [ivHex, encryptedText] = encrypted.split(':');
        const iv = CryptoJS.enc.Hex.parse(ivHex); // Parse the IV
        const key = CryptoJS.enc.Utf8.parse(SECRET_KEY); // Parse the key
        const ciphertext = CryptoJS.enc.Hex.parse(encryptedText); // Parse the ciphertext
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: ciphertext }, // Ciphertext as a WordArray object
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        );
        return decrypted.toString(CryptoJS.enc.Utf8); // Convert to UTF-8 string
    };

    const handleMail = () =>{
        const dataMail = {
            "password": decrypt(values.hashed_password),
            "email": values.email,
            "clientId": values.username
        }
        axios.post(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/newPassword`, dataMail, { headers })
        .then(res => {
            toast.success('Email envoyé avec succès au client', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            console.log(res, 'gigi');
        }).catch(err => {
            console.error(err);
            toast.error("Échec de l'envoi de l'e-mail. Veuillez réessayer.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        })
    }
    if (!isVisible) return null;

    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4' id="wrapper" onClick={handleClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto">
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Modifier l'utilisateur</h2>
                    <button type="button" className="text-slate-400 hover:text-slate-600" onClick={() => onClose()}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <form className="px-6 py-5" onSubmit={handleSubmit}>
                    <div className="grid gap-4 md:grid-cols-2">
                        <div className="mb-4">
                            <label htmlFor="username" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nom Client / Client ID</label>
                            <input type="text" name="username" id="username" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" required onChange={e => setValues({ ...values, username: e.target.value })} defaultValue={choosenId.username} />
                        </div>
                        <div className="mb-4">
                            <label htmlFor="email" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Email</label>
                            <input type="text" name="email" id="email" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " required defaultValue={choosenId.email} onChange={e => setValues({ ...values, email: e.target.value })} />
                        </div>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="id_pdv" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Id Pdv</label>
                        <input type="text" name="id_pdv" id="id_pdv" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " required defaultValue={choosenId.id_pdv} onChange={e => setValues({ ...values, id_pdv: e.target.value })} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="roles" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Autorisé</label>
                        <select id="roles" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" defaultValue={choosenId.authorized === null ? 'no' : choosenId.authorized} onChange={e => setValues({ ...values, authorized: e.target.value })}>
                            <option value="yes" >Yes</option>
                            <option value="no">No</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="stock" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Droit</label>
                        <select id="stock" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" defaultValue={choosenId.pages === null ? 'all' : choosenId.pages} onChange={e => setValues({ ...values, pages: e.target.value })}>
                            <option value="stock_only">Changement de Stock</option>
                            <option value="all">Changement Prix et Stock</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="roles" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Role</label>
                        <select id="roles" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" defaultValue={choosenId.role} onChange={e => setValues({ ...values, role: e.target.value })}>
                            <option value="5">Utilisatuer (stock uniquement)</option>
                            <option value="1">Gérant (stock et prix)</option>
                            <option value="2">Moderateur</option>
                            <option value="3">Admin</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="ecran" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Ecran</label>
                        <input type="text" name="ecran" id="ecran" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " required defaultValue={choosenId.ecran === null ? '1' : choosenId.ecran} onChange={e => setValues({ ...values, ecran: e.target.value })} />
                    </div>
                    <div className="mb-2 grid items-center gap-4 rounded-lg border border-slate-200 bg-slate-50 p-4 md:grid-cols-2">
                        <div className="text-center text-sm text-slate-700">
                            <span className="font-semibold text-slate-500">Password: </span>
                            <span className='font-sans'>{choosenId.hashed_password ? decrypt(choosenId.hashed_password) : 'Empty Password'}</span>
                        </div>
                        <button type="button" className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600" onClick={handleMail}>Envoyer le mot de passe au client</button>
                    </div>
                    <div className='mt-8 flex justify-between'>
                        <Popup trigger=
                            {<button type="button" className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700" > Supprimer </button>}
                            position="right center">
                            <div className="mb-2 text-sm text-slate-700">Est-ce votre dernier mot?</div>
                            <div className="flex justify-between gap-2">
                                <button type="button" className="rounded-lg bg-red-600 px-3 py-2 text-sm font-medium text-white hover:bg-red-700" onClick={handleDelete}> Accepter </button>
                                <button type="button" className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50" onClick={close}> Annuler </button>
                            </div>
                        </Popup>
                        <button type="submit" className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">Enregistrer</button>
                    </div>
                    <div className="py-4 text-center">
                        <p id="error" className='text-red-600'></p>
                    </div>
                </form>
            </div>
            <ToastContainer />
        </div>
    )
}

export default ModalModifyUser;
